import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'formik'

import { t } from 'translations'

const AutoRadio = ({ buttonsPerRow, fieldClass, labels, options, moduleName, inputGroup, groupState, setGroupState, ...props }) => {
  // If pass boolean values to options, need to do the comparison in 'checked' attribute as strings
  // and need to pass a string to the field.onChange()() handler when use component in a form with a 'Submit' button
  return (
    <div className="row">
      {options.map((option, i) => (
        <Field key={option} {...props}>
          {({ field }) => {
            const columnWidth = buttonsPerRow ? String(Math.floor(12 / buttonsPerRow)) : '12'

            return (
              <div className={`col-${columnWidth} d-flex flex-nowrap align-items-baseline pl-0 ${fieldClass}`}>
                <input
                  {...props}
                  {...field}
                  className="m-2"
                  type="radio"
                  checked={String(field.value) === String(option)}
                  onChange={async () => {
                    if (groupState && setGroupState) {
                      // If awaiting save confirmation from previous click disable setting new value
                      if (groupState[moduleName + field.name] === 'loading') return

                      // Set icon display to show spinner
                      setGroupState({ ...groupState, [moduleName + field.name]: 'loading' })
                    }

                    // If option is a boolean and use form with submit button,
                    // handler passed to '<Formik onSubmit={x}>' will need to convert string to boolean manually,
                    // since passing boolean 'option' below instead of 'String(option)' causes crash
                    field.onChange(field.name)(String(option))

                    // If using own onChange handler that runs when radio is changed
                    if (props.onChange) await props.onChange(option)

                    if (groupState && setGroupState) {
                      // Set icon display to show checkmark
                      setGroupState({ ...groupState, [moduleName + field.name]: 'saved' })
                    }
                  }}
                  id={`${moduleName}-${props.name}-${labels[i] || option}`}
                />
                <label htmlFor={`${moduleName}-${props.name}-${labels[i] || option}`} className="overflow-wrap-anywhere mb-0">
                  {/* If pass boolean values to options, read labels instead for strings to display */}
                  {t(`${props.translation}.OPTIONS.${labels[i] || option}`)}
                </label>
              </div>
            )
          }}
        </Field>
      ))}
    </div>
  )
}

export default AutoRadio

// Set the proptypes for validation
AutoRadio.propTypes = {
  buttonsPerRow: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  labels: PropTypes.arrayOf(PropTypes.string),
  moduleName: PropTypes.string,
  name: PropTypes.isRequired,
  onChange: PropTypes.func,
  options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.bool)]).isRequired,
  rightLabel: PropTypes.bool,
  translation: PropTypes.string.isRequired
}

AutoRadio.defaultProps = {
  buttonsPerRow: 1,
  labels: [],
  moduleName: ''
}
